export default __webpack_public_path__ + "static/media/footer_animation.561d32b4.gif";